const { Map, List } = require('immutable');
const warn = require('debug')('svtse:resolve:error');

export function resourceAttributes(resource) {
	return resource.withMutations((map) => {
		return map.get('attributes', []).reduce((reduction, attribute, name) => { return reduction.set(name, attribute); }, map);
	}).delete('attributes');
}

export function resourceRelationships(resource, cache, include = [], path = '') {
	if(include.indexOf('*') > -1) {
		warn('WARNING: resolving without specifying includes may result in infinate loops and will be depricated');
	}

	return resourceAttributes(resource).withMutations((map) => {
		map.get('relationships', Map()).reduce((reduction, relationship, name) => {	
			const current = [path, name].join('.').replace(/^\.+/,'');
			if (include.indexOf(current) < 0 && include.indexOf('*') < 0) {
				return reduction;
			}
		
			const data = relationship.get('data');
			if(Map.isMap(data)) {
				const endpoint = `/${data.get('type')}/${data.get('id')}`;
				const resource = cache.get(endpoint);
				if(resource) {
					return reduction
									.set(name, resourceRelationships(resource, cache, include, current))
									.deleteIn(['relationships', name]);
				}
			} else if(List.isList(data)) {
				reduction.set(name, data.reduce((list, data) => {
						const endpoint = `/${data.get('type')}/${data.get('id')}`;
						const resource = cache.get(endpoint);
						if(resource) {
							return list.push(resourceRelationships(resource, cache, include, current));
						} else {
							return list;
						}
				}, List()));

				const missing = data.filter((data) => cache.get(`/${data.get('type')}/${data.get('id')}`, Map()).isEmpty());
				if(missing.isEmpty()) {
					reduction.deleteIn(['relationships', name]);
				} else {
					reduction.setIn(['relationships', name], missing);
				}

				return reduction;
			}
			return reduction;
		
		}, map);

		if(map.get('relationships', Map()).isEmpty()) {
			map.delete('relationships');
		}
		
		return map;
	});
}

export const resolveResource = (resource, cache, include = ['*']) => resourceRelationships(resource, cache, include);



/** WEBPACK FOOTER **
 ** ./app/selectors/resolve.js
 **/